var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.name !== 'NoLicense')?_c('v-dialog',{attrs:{"value":_vm.value,"width":"400px","persistent":"","overlay-opacity":"0.8"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.initializingText)+" ")]),_c('v-card-text',[_vm._v(" Please wait... ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }